export default __webpack_public_path__ + "static/media/CODM_THUMBNAIL_5.e9e774fc.png";